var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"technology-version-table-cell"},[_c('v-chip-group',{attrs:{"show-arrows":true}},_vm._l((_vm.versions),function(version,index){return _c('v-chip',{key:`${version}-${index}`,staticClass:"chip",attrs:{"x-small":"","label":"","outlined":"","text-color":"black"}},[_vm._v(" "+_vm._s(version)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }